<div class="confirm-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  
  <mat-dialog-content>
    <div class="warning-section">
      <mat-icon class="warning-icon">warning</mat-icon>
      <p class="warning-text" style="white-space: pre-line;">{{ data.message }}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button 
      mat-button 
      *ngIf="!data.hideCancel"
      (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button 
      mat-raised-button 
      [color]="getConfirmButtonColor()"
      (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>